// Auto-generated skeleton for Team

import { User } from './User'
import { Building } from './Building'
import { PhoneNumber } from './PhoneNumber'

export const Team: Api.Team = {
	id: 0,
	hp_id: null,
	user: User,
	user_id: 0,
	salutation: '',
	first_name: null,
	last_name: null,
	can_post: false,
	can_update: false,
	can_delete: false,
	can_settings: false,
	can_view_all_reports: false,
	created: null,
	updated: null,
	disable_contactdata: false,
	active: true,
	buildings: [],
	phonenumbers: [PhoneNumber],
}
